import { joinClasses } from "@/utils/styling";

interface SelectProps<
  TOption extends Record<string, string>,
  TValueKey extends keyof TOption = "Value",
  TTextKey extends keyof TOption = "Text"
> extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: TOption[];
  optionValueKey?: TValueKey;
  optionTextKey?: TTextKey;
  selectText?: string;
}

export default function Select<
  TOption extends Record<string, string>,
  TValueKey extends keyof TOption = "Value",
  TTextKey extends keyof TOption = "Text"
>({
  options,
  optionValueKey,
  optionTextKey,
  selectText = "None Selected",
  className,
  ...attributes
}: SelectProps<TOption, TValueKey, TTextKey>) {
  const valueKey = (optionValueKey ?? "Value") as TValueKey;
  const textKey = (optionTextKey ?? "Text") as TTextKey;

  return (
    <select
      {...attributes}
      className={joinClasses("chld-select", "form-select", className)}
    >
      <option value="">{selectText}</option>
      {options.map((x) => (
        <option value={x[valueKey]} key={String(x[valueKey])}>
          {x[textKey]}
        </option>
      ))}
    </select>
  );
}
